import { render } from "./DocBonusForm.vue?vue&type=template&id=7ddabc0a"
import script from "./DocBonusForm.vue?vue&type=script&lang=js"
export * from "./DocBonusForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__